var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, Metrika, Logger /*, ApiOK*/ } from './../classes';
import { YandexGames } from './../sdk';
import bridge from '@vkontakte/vk-bridge';
import { fakeAd } from '../utils/fakeAd';
import { countHours, formatTime } from '../utils/datetime';
import { MS_IN_ONE_HOUR } from '../../app/const/math';
import { appStorage } from '../../app/storage';
var MS_IN_ONE_SEC = 1000;
var MS_IN_ONE_MINUTE = 60 * MS_IN_ONE_SEC;
var MS_IN_ONE_DAY = MS_IN_ONE_MINUTE * 60 * 24;
var SHOW_ACTION = 's';
var HIDE_ACTION = 'h';
var log = Logger.get('SDK:AD', true).log;
function currentTime() {
    return Date.now();
}
var Ad = /** @class */ (function () {
    function Ad() {
    }
    // Settings
    Ad.setNativeInterval = function (sec) {
        Ad.nativeInterval = sec * MS_IN_ONE_SEC;
        DEVELOPMENT && log("\u0418\u043D\u0442\u0435\u0440\u0432\u0430\u043B \u043F\u043E\u043A\u0430\u0437\u0430 \u043D\u0430\u0442\u0438\u0432\u043D\u043E\u0439 \u0440\u0435\u043A\u043B\u0430\u043C\u044B: ".concat(formatTime(Ad.nativeInterval), " \u043C\u0438\u043D."));
    };
    Ad.setNativeLimit = function (n) {
        Ad.nativeLimit = n;
        DEVELOPMENT && log("\u041B\u0438\u043C\u0438\u0442 \u043F\u043E\u043A\u0430\u0437\u0430 \u043D\u0430\u0442\u0438\u0432\u043D\u043E\u0439 \u0440\u0435\u043A\u043B\u0430\u043C\u044B: ".concat(Ad.nativeLimit, " \u0448\u0442\u0443\u043A."));
    };
    Ad.setRewardedInterval = function (sec) {
        Ad.rewardedInterval = sec * MS_IN_ONE_SEC;
        DEVELOPMENT && log("\u0418\u043D\u0442\u0435\u0440\u0432\u0430\u043B \u043F\u043E\u043A\u0430\u0437\u0430 Rewarded \u0432\u0438\u0434\u0435\u043E: ".concat(formatTime(Ad.rewardedInterval), " \u043C\u0438\u043D."));
    };
    Ad.setUseWaterfall = function (useWaterfall) {
        this.useWaterfall = useWaterfall;
        DEVELOPMENT && log("\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F Native \u0432\u043C\u0435\u0441\u0442\u043E Rewarded: ".concat(useWaterfall ? 'true' : 'false'));
    };
    Ad.setNativeTimeout = function (sec) {
        this.showNativeTime = currentTime() - Ad.nativeInterval + sec * MS_IN_ONE_SEC;
        if (DEVELOPMENT) {
            var delta = this.showNativeTime + this.nativeInterval - currentTime();
            log("\u041F\u043E\u043A\u0430\u0437\u044B Native \u043D\u0430\u0447\u043D\u0443\u0442\u0441\u044F \u0447\u0440\u0435\u0437: ".concat(formatTime(Math.max(0, delta)), " \u043C\u0438\u043D."));
        }
    };
    Ad.setFreeHoursAfterPurchase = function (hours) {
        Ad.adFreeHoursAfterPurchase = hours;
    };
    Ad.setFreeHoursForNewUsers = function (hours) {
        Ad.adFreeHoursForNewUsers = hours;
    };
    Ad.saveNativeTime = function () {
        this.showNativeTime = currentTime();
    };
    Ad.getNativeTime = function () {
        return this.showNativeTime;
    };
    Ad.saveRewardedTime = function () {
        appStorage.upd({ rewardedTime: currentTime() });
    };
    Ad.getRewardedTime = function () {
        return appStorage.get().rewardedTime;
    };
    Ad.checkTimeout = function (usageTime, interval, lable) {
        if (currentTime() - usageTime < interval) {
            if (DEVELOPMENT) {
                var time = interval - (currentTime() - usageTime);
                log("\u0420\u0435\u043A\u043B\u0430\u043C\u0430 \u0442\u0438\u043F\u0430 \"".concat(lable, "\" \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0447\u0435\u0440\u0435\u0437 ").concat(formatTime(time), "."));
            }
            return false;
        }
        return true;
    };
    Ad.checkPurchaseTime = function () {
        return Date.now() - appStorage.get().purchaseTime > MS_IN_ONE_HOUR * Ad.adFreeHoursAfterPurchase;
    };
    // Native
    Ad.checkNative = function () {
        var _a = appStorage.get(), created = _a.created, learned = _a.learned;
        if (DEVELOPMENT && location.search.includes('checkNativeTrue')) {
            return true;
        }
        if (!learned) {
            if (DEVELOPMENT)
                log('Реклама не будет показана. Причина: обучение.');
            Metrika.params({ adsDisabled: { learned: 1 } });
            return false;
        }
        if (!Ad.checkTimeout(Ad.getNativeTime(), Ad.nativeInterval, 'native')) {
            if (DEVELOPMENT)
                log('Реклама не будет показана. Причина: временной интервал.');
            Metrika.params({ adsDisabled: { time: 1 } });
            return false;
        }
        if (countHours(created) < Ad.adFreeHoursForNewUsers) {
            if (DEVELOPMENT)
                log('Реклама не будет показана. Причина: новый пользователь.');
            Metrika.params({ adsDisabled: { newUser: 1 } });
            return false;
        }
        if (!Ad.checkPurchaseTime()) {
            if (DEVELOPMENT)
                log('Реклама не будет показана. Причина: покупки.');
            Metrika.params({ adsDisabled: { purchases: 1 } });
            return false;
        }
        if (Ad.nativeCounter > Ad.nativeLimit) {
            if (DEVELOPMENT)
                log('Реклама не будет показана. Лимит числа показов.');
            Metrika.params({ adsDisabled: { limit: 1 } });
            return false;
        }
        return true;
    };
    Ad.showNative = function (userCallback) {
        var _this = this;
        var callback = function (wasShown) {
            if (wasShown)
                _this.nativeCounter++;
            if (userCallback)
                userCallback(wasShown);
        };
        if (!Ad.checkNative()) {
            callback(false);
            return;
        }
        if (FOR_YANDEX) {
            Ad.showYandexNative(callback);
        }
        else if (FOR_VK) {
            Ad.showVkNative(callback);
        }
        else if (FOR_OK) {
            // Ad.showOkNative(cb)
        }
        else {
            callback(false);
        }
    };
    Ad.showYandexNative = function (cb) {
        var _this = this;
        if (FOR_YANDEX) {
            Ad.emitShow();
            YandexGames.showFullscreenAdv(function (wasShown) {
                cb && cb(wasShown);
                // wasShown && Ad.saveNativeTime()
                Metrika.params({ fullscreenAdv: wasShown ? "count-".concat(_this.nativeCounter) : 'not_shown' });
            })
                .catch(function (err) {
                cb && cb(false);
                Metrika.params({ fullscreenAdv: { show_catch: 1 } });
                Metrika.logError(err);
            })
                .finally(function () {
                Ad.saveNativeTime();
                Ad.emitHide();
            });
        }
    };
    Ad.showVkNative = function (cb) {
        if (FOR_VK) {
            Ad.emitShow();
            if (DEVELOPMENT) {
                return fakeAd(5000, function (success) {
                    if (success) {
                        Ad.saveNativeTime();
                    }
                    cb(success);
                    Ad.emitHide();
                });
            }
            bridge
                // @ts-ignore
                .send('VKWebAppShowNativeAds', { ad_format: 'interstitial' })
                .then(function (data) {
                var _a;
                cb && cb(data.result);
                // if (data.result) {
                //   Ad.saveNativeTime()
                // }
                Metrika.params({ interstitial: (_a = {}, _a[data.result ? 'show_ok' : 'not_shown'] = 1, _a) });
            })
                .catch(function (error) {
                cb && cb(false);
                Metrika.params({ interstitial: { show_catch: 1 } });
                Metrika.logError(error);
            })
                .finally(function () {
                Ad.saveNativeTime();
                Ad.emitHide();
            });
        }
    };
    // private static showOkNative(cb?: adCallback): void {
    //   if (FOR_OK) {
    //     Ad.emitShow()
    //     ApiOK.showAd(() => {
    //       Ad.emitHide()
    //     })
    //   }
    // }
    // Rewarded
    Ad.showRewarded = function (userCallback) {
        var _this = this;
        var callback = function (wasShown) {
            if (wasShown)
                _this.rewardedCounter++;
            if (userCallback)
                userCallback(wasShown);
        };
        Ad.checkRw(function (available) {
            if (available) {
                Ad.showRw(function (wasShown) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (wasShown) {
                            callback(true);
                        }
                        else {
                            callback(false);
                        }
                        return [2 /*return*/];
                    });
                }); });
            }
            else {
                callback(false);
            }
        });
    };
    Ad.checkRw = function (cb) {
        if (!Ad.checkTimeout(Ad.getRewardedTime(), Ad.rewardedInterval, 'rewarded')) {
            cb && cb(false);
            return;
        }
        if (FOR_YANDEX) {
            Ad.rewardedCheckTime = currentTime();
            cb && cb(true);
        }
        else if (FOR_VK) {
            Ad.checkVkRw(cb);
        }
        else {
            cb && cb(false);
        }
    };
    // https://dev.vk.com/bridge/VKWebAppShowNativeAds
    Ad.checkVkRw = function (cb) {
        if (FOR_VK) {
            bridge
                // @ts-ignore
                .send('VKWebAppCheckNativeAds', { ad_format: 'reward', use_waterfall: Ad.useWaterfall })
                .then(function (data) {
                if (data && data.result) {
                    Ad.rewardedCheckTime = currentTime();
                    cb && cb(true);
                    Metrika.params({ rewarded: { check_true: 1 } });
                }
                else {
                    cb && cb(false);
                    Metrika.params({ rewarded: { check_false: 1 } });
                }
            })
                .catch(function (_) {
                cb && cb(false);
                Metrika.params({ rewarded: { check_catch: 1 } });
            });
        }
    };
    Ad.isAvailableRw = function () {
        return currentTime() - Ad.rewardedCheckTime < 15000;
    };
    Ad.showRw = function (cb) {
        if (FOR_YANDEX) {
            Ad.showYandexRw(cb);
        }
        else if (FOR_VK) {
            if (DEVELOPMENT) {
                fakeAd(5000, cb, true);
            }
            else {
                Ad.showVkRw(cb);
            }
        }
        else {
            cb(false);
        }
    };
    Ad.showVkRw = function (cb) {
        if (FOR_VK) {
            Ad.emitShow();
            bridge
                // @ts-ignore
                .send('VKWebAppShowNativeAds', { ad_format: 'reward', use_waterfall: Ad.useWaterfall })
                .then(function (_) {
                cb(true);
                Ad.saveRewardedTime();
                Metrika.params({ rewarded: { show_ok: 1 } });
            })
                .catch(function (error) {
                if (error && error.error_data && error.error_data.error_code && error.error_data.error_code === 4) {
                    cb(true);
                }
                else {
                    cb(false);
                }
                Metrika.params({ rewarded: { show_catch: 1 } });
                Metrika.logError(error);
            })
                .finally(function () { return Ad.emitHide(); });
        }
    };
    Ad.showYandexRw = function (cb) {
        if (FOR_YANDEX) {
            var success_1 = false;
            Ad.emitShow();
            YandexGames.showRewardedVideo({
                onOpen: function () {
                    Metrika.params({ rewarded: { open: 1 } });
                },
                onRewarded: function () {
                    success_1 = true;
                    Ad.saveRewardedTime();
                    Metrika.params({ rewarded: { rewarded: 1 } });
                },
                onClose: function () {
                    cb(success_1);
                    Ad.emitHide();
                    Metrika.params({ rewarded: { close: 1 } });
                },
                onError: function () {
                    cb(false);
                    Ad.emitHide();
                    Metrika.params({ rewarded: { error: 1 } });
                },
            });
        }
    };
    // Sticky
    Ad.showBanner = function () {
        if (DEVELOPMENT) {
            log('Показ баннеров.');
        }
        if (FOR_YANDEX) {
            YandexGames.showBannerAdv();
        }
        if (FOR_VK) {
            if (window.innerHeight / window.innerWidth < 2) {
                if (DEVELOPMENT) {
                    log('Баннеры не будут включены. Причина: маленький экран.');
                }
                return;
            }
            // https://dev.vk.com/bridge/VKWebAppShowBannerAd
            bridge
                // @ts-ignore
                .send('VKWebAppShowBannerAd', { banner_location: 'top', layout_type: 'resize', can_close: false })
                .then(function () {
                Metrika.params({ banner: { ok: 1 } });
            })
                .catch(function (err) {
                Metrika.logError(err);
                Metrika.params({ banner: { error: 1 } });
            });
        }
    };
    Ad.hideBanner = function () {
        if (DEVELOPMENT) {
            log('Отключение баннеров.');
        }
        if (FOR_YANDEX) {
            YandexGames.hideBannerAdv();
        }
    };
    // Events
    Ad.onShow = function (fn) {
        Ad.emitter.on(SHOW_ACTION, fn);
    };
    Ad.onHide = function (fn) {
        Ad.emitter.on(HIDE_ACTION, fn);
    };
    Ad.emitShow = function () {
        Ad.showing = true;
        Ad.emitter.emit(SHOW_ACTION, {});
    };
    Ad.emitHide = function () {
        Ad.showing = false;
        Ad.emitter.emit(HIDE_ACTION, {});
    };
    Ad.showing = false;
    Ad.emitter = new EventEmitter();
    Ad.nativeInterval = 2 * MS_IN_ONE_MINUTE;
    Ad.showNativeTime = 0;
    Ad.nativeCounter = 0;
    Ad.nativeLimit = 1000000;
    Ad.rewardedInterval = 0;
    Ad.rewardedCheckTime = 0;
    Ad.rewardedCounter = 0;
    Ad.useWaterfall = true;
    Ad.adFreeHoursAfterPurchase = 72;
    Ad.adFreeHoursForNewUsers = 48;
    return Ad;
}());
export { Ad };
if (DEVELOPMENT) {
    // @ts-ignore
    window['makeTheUserOld'] = function () { return appStorage.upd({ created: Date.now() - 5 * MS_IN_ONE_DAY }); };
}
